(() => {
  const dialogs = () => [document.getElementById('vd-search-dialog'), document.getElementById('vd-menu-dialog')].filter(Boolean);
  function reflectState() {
    const open = dialogs().some(dialog => dialog.open);
    document.body.classList.toggle('vd-dialog-is-open', open);
    document.querySelectorAll('[data-vd-search-open], [data-vd-menu-open]').forEach(button => {
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(Boolean(dialog && dialog.open)));
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-vd-search-open], [data-vd-menu-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog) return;
      event.preventDefault();
      dialogs().forEach(other => { if (other !== dialog && other.open) other.close(); });
      if (!dialog.open) dialog.showModal();
      reflectState();
      const input = dialog.querySelector('input[type="search"]');
      if (input) input.focus({ preventScroll: true });
    }
    if (event.target.closest('[data-vd-dialog-close]')) {
      event.target.closest('dialog').close();
    }
  });
  dialogs().forEach(dialog => {
    dialog.addEventListener('close', reflectState);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });
  const dialog = document.getElementById('vd-search-dialog');
  if (!dialog) return;
  const input = dialog.querySelector('#vd-search-input');
  const output = dialog.querySelector('[data-vd-search-output]');
  const popular = dialog.querySelector('[data-vd-search-popular]');
  const status = dialog.querySelector('[data-vd-search-status]');
  let timer;
  let controller;
  let generation = 0;
  input.addEventListener('input', () => {
    const query = input.value.trim();
    const current = ++generation;
    clearTimeout(timer);
    if (controller) controller.abort();
    status.textContent = '';
    output.hidden = true;
    output.replaceChildren();
    popular.hidden = query.length >= 2;
    if (query.length < 2) {
      output.removeAttribute('aria-busy');
      return;
    }
    status.textContent = dialog.dataset.loading;
    output.setAttribute('aria-busy', 'true');
    timer = setTimeout(async () => {
      controller = new AbortController();
      const url = new URL(dialog.dataset.suggestUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      url.searchParams.set('section_id', 'vd-predictive-search');
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (current !== generation) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const results = parsed.querySelector('[data-vd-search-results]');
        if (!results) throw new Error('Search unavailable');
        output.replaceChildren(document.importNode(results, true));
        output.hidden = false;
        status.textContent = '';
      } catch (error) {
        if (error.name !== 'AbortError' && current === generation) status.textContent = dialog.dataset.error;
      } finally {
        if (current === generation) output.removeAttribute('aria-busy');
      }
    }, 220);
  });
})();